import { useEffect, useState } from 'react';

/**
 * This hook ensures consistent widths for similar elements in the UI by identifying the highest width among them.
 *
 * We need it to maintain alignment in the layout.
 */
export const useGetHighestWidth = (querySelector: string) => {
  const [highestWidth, setHighestWidth] = useState<undefined | number>();

  useEffect(() => {
    const updateHighestWidth = () => {
      let width: number | undefined;

      document.querySelectorAll(querySelector).forEach((el) => {
        // @ts-expect-error the type doesn't have style on it
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const style = el.style!;

        const prevWidth = style.width;

        style.width = '';

        if (!width || el.clientWidth > width) {
          width = el.clientWidth;
        }

        style.width = prevWidth;
      });

      setHighestWidth(width);
    };

    updateHighestWidth();

    window.addEventListener('resize', updateHighestWidth);

    return () => window.removeEventListener('resize', updateHighestWidth);
  }, [querySelector]);

  return highestWidth;
};
